import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import ModalBonus from './bonus';
import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  bonus?: boolean;
}

export default function ModalSelo(props: Props) {
  const modalID = 'validation-selo';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [bonusText, setBonusText] = useState(false);

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (props?.bonus && !bonusText) {
    return <ModalBonus onClose={() => closeModal()} onConfirm={() => setBonusText(true)} />;
  }

  return (
    <ConfirmacaoDaAcao
      title="Conceder Selo Realização Destaque"
      onClose={() => {
        closeModal();
        setBonusText(false);
      }}
      onConfirm={() => {
        callback({ id: 'selo' });
        closeModal();
      }}
    >
      <p className="m-0">
        Você pode conceder o Selo Realização Destaque para até 10% (com arredondando para cima) das entregas que você bonificou,
        se considerar que a realização é extraordinária para o contexto da Unidade/Diretoria.
      </p>
    </ConfirmacaoDaAcao>
  );
}
